<footer class="w-full p-4 flex justify-center text-xs sm:text-base">
  <a href="https://github.com/muazamkamal/timesheet" class="hover:underline"
    >Made with ❤</a
  >
  &nbsp
  <a href="https://github.com/muazamkamal" class="hover:underline"
    >by Muazam Kamal</a
  >
</footer>
